export enum ELicencePrintStatus {
  WAITING = 'fb3b663b-841d-4009-a2e1-90587318716b',
  BATCHED = '9cc7956a-e4db-4b75-b3c2-a2a257e49e83',
  AVAILABLE = '83371c98-fb1a-4c63-adf8-54e96943b625',
  FAILED_TO_SEND = '0652b658-655f-4cd9-9f2c-132691a6e84d',
  CANCELLED = 'b44a4d5a-7c48-46d5-a1af-f360b4b45ed0',
  FAILED = 'bde9a19c-5902-4eb7-aae0-64e5fbc40b3a',
  PRINTED = 'e4dcb10e-8142-4a02-9f29-756c2e21fec8',
  MISSING = '201d3708-a0da-4836-8dd0-5fefea096966',
}
